@if (!loadingMore() && loading()) {
  <div class="tt-attachment-search-result-list_loading">
    <tt-spinner />
    <p>{{ 'SearchResult.List.Searching' | transloco }}</p>
  </div>
} @else if (error()) {
  <div class="tt-attachment-search-result-list_error">
    {{ error }}
  </div>
} @else if (this.searchResults().length > 0) {
  <div class="tt-attachment-search-result-list_list">
    @for (searchResult of searchResults(); track searchResult.uniqueId; let i = $index) {
      <tt-attachment-card [variant]="'search'" [version]="searchResult" (click)="goToAttachment(searchResult)" />
    }

    @if (!hasMoreResults()) {
      <div class="tt-attachment-search-result-list_no-more">
        <p>{{ 'SearchResult.List.NoMoreResults' | transloco }}</p>
      </div>
    }
  </div>
} @else if (searchTerm() && !loading()) {
  <tt-no-results
    [actionLabel]="'SearchResult.List.ClearSearch'"
    [title]="'SearchResult.List.NoResults'"
    (actionClicked)="clearSearch.emit()" />
}

@if (loadingMore()) {
  <div class="tt-attachment-search-result-list_loading">
    <tt-spinner />
  </div>
}

@if (this.searchResults().length > 0 && hasMoreResults) {
  <div class="tt-attachment-search-result-list_end-component" inViewport (visible)="$event && loadNextPage.emit()"></div>
}
